/**
* ...
* @author DefaultUser (Tools -> Custom Arguments...)
*/
/**
 * package: com.inq.ui
 * class: TextArea
 * @extends com.inq.ui.Container 
 * @constructor
 */
com.inq.ui.TextArea = function(_id) {
	com.inq.ui.Container.call(this,_id);
	this._div.innerHTML = '<div id="tc_chat_box' + _id + '"><div style="background-color:transparent;overflow: hidden; overflow-x: hidden; overflow-y: hidden;"></div></div>';
	this._ta = this._div.getElementsByTagName("DIV")[0];
	this._tableContainer = this._div.getElementsByTagName("DIV")[1];
	this._setHtmlText("");
	this.setStyle("backgroundColor","#FFFFFF");
	this._tableContainer.innerHTML = "";
	this._ta.style.cssText = "position:absolute; top:0px; left:0px; height:100%; width:100%; overflow:auto; overflow-x:hidden; overflow-y:auto;";
	this.bindListeners();
	this.tableCreated = false;
	/** @type {com.inq.ui.Button} */
	this.scrollBtn = Application.application.getMxmlItem("scrollBtn");
	/** @type {com.inq.ui.NativeScroller} */
	this.nativeScroller = new com.inq.ui.NativeScroller(this._ta);
	this._ta.onscroll = $bind(this, this.doScroll);
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.TextArea, "com.inq.ui.TextArea");

/**
 * _getStyleSheet
 *
 * $type TFun([],TInst(com.inq.ui.StyleSheet,[]))
 * private function _getStyleSheet():StyleSheet
 * @private
 * @this com.inq.ui.TextArea
 * @return {com.inq.ui.StyleSheet}
 */
com.inq.ui.TextArea.prototype._getStyleSheet = function() {
	return this._styleSheet;
};


/**
 * _setStyleSheet
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function _setStyleSheet(val:Dynamic):Dynamic
 * @private
 * @this com.inq.ui.TextArea
 * @param {null}  val 
 * @return {null}
 */
com.inq.ui.TextArea.prototype._setStyleSheet = function(val) {
	return null;
};


/**
 * _setHtmlText
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => false }],TDynamic(null))
 * private function _setHtmlText (val:String):Dynamic
 * @private
 * @this com.inq.ui.TextArea
 * @param {string}  val 
 * @return {null}
 */
com.inq.ui.TextArea.prototype._setHtmlText = function(val) {
	this._tableContainer.innerHTML = val;
};

/**
 * Adds transcript to table. To prevent
 * table recreating every time when message received,
 * we create table only when we get the first message
 *
 * @this com.inq.ui.TextArea
 * @param {string} transcript
 * @private
 */
com.inq.ui.TextArea.prototype._addTranscriptToTable = function(transcript) {
	transcript = this.reformatTranscriptByNewLines(transcript);
	if (!this.tableCreated) {
		this._setHtmlText("<table role=\"presentation\">" + transcript + "</table>");
		this.tableCreated = true;
	} else {
		this._ta.getElementsByTagName("table")[0].innerHTML = transcript;
	}
};

/**
 * Replaces "\n" if presents with <br/> tag
 * to correctly display multi-line messages
 *
 * @param {string} transcript
 * @return {string} multi-lined transcript
 */
com.inq.ui.TextArea.prototype.reformatTranscriptByNewLines = function(transcript) {
	return transcript.split("\n").join("<br/>");
};

/**
 * _getHtmlText
 *
 * $type TFun([],TInst(String,[]))
 * private function _getHtmlText ():String
 * @private
 * @this com.inq.ui.TextArea
 * @return {string}
 */
com.inq.ui.TextArea.prototype._getHtmlText = function() {
	if (this._tableContainer == null) {
		return "";
	}
	return this._tableContainer.innerHTML;
};

/**
 * setID
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * override  public function setID(val:String):Void
 * @override
 * @public
 * @this com.inq.ui.TextArea
 * @param {string}  val
 * @return {void}
 */
com.inq.ui.TextArea.prototype.setID = function(val) {
	com.inq.ui.Container.prototype.setID.call(this, val);
	if (this._tableContainer != null) {
		this._tableContainer.id = Std.string(this._div.id) + "_span";
	}
};

/**
 * Returns true if the chat window is scrolled to the bottom
 *
 * @return {boolean} - true if at bottom
 */
com.inq.ui.TextArea.prototype.isScrolledToBottom = function () {
	/**
	 * @type {number} - unintentional scrolling tolerance in pixels
	 */
	var unintentionalScrollingBuffer = 10;

	/*
	 * Note: On systems using display scaling,
	 * scrollTop may give you a decimal value.
	 * Ref:https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTop
	 * Math.ceil the scrollTop value when position is equal or smaller than
	 * clientHeight we are at the bottom.
	 * (Works for negative and positive zoom/scaling)
	 */
	var totalScrollHeight = this._ta.scrollHeight - Math.ceil(this._ta.scrollTop);
	var clientHeight = this._ta.clientHeight + unintentionalScrollingBuffer;

	return totalScrollHeight <= clientHeight;
};

/**
 * getMaxScrollPosition
 *
 * private function getMaxScrollPosition():Point
 * @private
 * @this com.inq.ui.TextArea
 * @return {com.inq.utils.Point}
 */
com.inq.ui.TextArea.prototype.getMaxScrollPosition = function() {
	/** @type {number} */
	var x = this._ta.scrollWidth;
	/** @type {number} */
	var y = this._ta.scrollHeight;
	return new com.inq.utils.Point(x,y);
};


/**
 * Scrolls the contents of this._ta vertically
 *
 * @public
 * @this com.inq.ui.TextArea
 * @param {com.inq.utils.Point}  p 
 * @return {void}
 */
com.inq.ui.TextArea.prototype.scrollToPosition = function(p) {
	this._ta.scrollTop = p.y;
};


/**
 * Scrolls to the bottom of the transcript. Usable on all platforms.
 *
 * @public
 * @this com.inq.ui.TextArea
 * @return {void}
 */
com.inq.ui.TextArea.prototype.scrollToBottom = function() {
	/** @type {number} */
	var pos = this.getMaxScrollPosition().y;
	this.scrollToPosition(new com.inq.utils.Point(0, pos));
};


/**
 * scrollToTop
 * Scrolls to the top of the transcript.  Usable on all platforms.
 *
 * $type TFun([],TEnum(Void,[]))
 * public function scrollToTop():Void
 * @public
 * @this com.inq.ui.TextArea
 * @return {void}
 */
com.inq.ui.TextArea.prototype.scrollToTop = function() {
	this.scrollToPosition(new com.inq.utils.Point(0,0));
};

/**
 * buildStyle
 *
 * $type TFun([],TEnum(Void,[]))
 * override private function buildStyle():Void
 * @override
 * @private
 * @this com.inq.ui.Button
 * @return {void}
 */
com.inq.ui.TextArea.prototype.buildStyle = function() {
	com.inq.ui.Container.prototype.buildStyle.call(this);
	/** @type {?string} */
	var tabindex = this.getStyle("tabindex");
	if(null != tabindex){
	this._div.setAttribute("tabindex", tabindex);
	}
};

/**
 *  applyStyle
 *
 * @param event
 */
com.inq.ui.TextArea.prototype.applyStyle = function(event) {
	com.inq.ui.Container.prototype.applyStyle.call(this);

	var alt = this.styles["alt"];
	alt = !alt ? "" : alt;
	if(this._backgroundImage != null) {
		this._backgroundImage.alt = alt;
	}
};

/**
 * Binds listeners
 */
com.inq.ui.TextArea.prototype.bindListeners = function () {
	if (com.inq.utils.Capabilities.isIphone()) {
		com.inq.utils.Capabilities.BindListener(this._ta, "touchend", this.commonClickHandler);
	} else {
		com.inq.utils.Capabilities.BindListener(this._ta, "click", this.commonClickHandler);
	}
};

/**
 * Removes listeners
 */
com.inq.ui.TextArea.prototype.cleanUp = function () {
	if (com.inq.utils.Capabilities.isIphone()) {
		com.inq.utils.Capabilities.UnbindListener(this._ta,"touchend", this.commonClickHandler);
	} else {
		com.inq.utils.Capabilities.UnbindListener(this._ta,"click", this.commonClickHandler);
	}
	this.nativeScroller.cleanUp();
};

/**
 * commonClickHandler - is used as a general listener for delegating events in messages.
 *
 * @param {MouseEvent|TouchEvent} event
 */
com.inq.ui.TextArea.prototype.commonClickHandler = function (event) {
	var eventTarget = event && event.target;
	if (eventTarget) {
		if (eventTarget.hasAttribute(com.inq.flash.client.chatskins.SkinControl.DATA_SURVEY_URL)) {
			Application.launchPostChatSurvey(event);
		}
	}
};

/**
 *  Resize element according to the new styles values
 *
 *  @override
 */
com.inq.ui.TextArea.prototype.resize = function() {
	com.inq.ui.Container.prototype.resize.call(this);
	if (this.scrollBtn && this._ta.scrollTop === 0) {
		this.scrollBtn.setVisible(false);
	}
};

/**
 * Dispatch scroll event
 *
 * @param {Event} event
 */
com.inq.ui.TextArea.prototype.doScroll = function(event) {
	/** @type {com.inq.events.Event} */
	var scrollEvent = new com.inq.events.Event(com.inq.events.Event.SCROLL, event);
	this.dispatchEvent(scrollEvent);
};


/** @type {string} */
com.inq.ui.TextArea.prototype.htmlText = null;
/** @type {com.inq.ui.StyleSheet} */
com.inq.ui.TextArea.prototype.styleSheet = null;
/** @private @type {null} */
com.inq.ui.TextArea.prototype._ta = null;
/** @private @type {null} */
com.inq.ui.TextArea.prototype._tableContainer = null;
/** @private @type {null} */
com.inq.ui.TextArea.prototype._textarea = null;
/** @private @type {com.inq.ui.StyleSheet} */
com.inq.ui.TextArea.prototype._styleSheet = null;


